import React from 'react';
import PropTypes from 'prop-types';

import { useApplicationState, useLabel } from '@atlas/core';
import { DefaultPopup } from '@atlas/ui';

import { useQuickDepositPostHog } from 'hooks/usePostHog';
import { QUICK_DEPOSIT_POPUP_TITLE_TYPE } from 'src/common/constants';
import {
  getBonusMinDeposit,
  pickBonusWithLowestMinDeposit,
} from 'src/common/utils/depositBonusUtils';
import { useBonusesContext } from 'src/components/BonusesProvider';
import QuickDepositForm from 'src/components/QuickDepositPopup/QuickDepositForm';
import useSetRedirectUrl from 'src/hooks/useSetRedirectUrl';

const FALLBACK_MIN_BONUS_AMOUNT = 3000;

const QuickDepositPopupContent = ({ afterDelay, onClose, onCloseClick }) => {
  const { wallet } = useApplicationState();
  const { currency } = wallet;

  const { activatedBonus, bonusesList, selectedBonus } = useBonusesContext();

  const listBonus = pickBonusWithLowestMinDeposit(bonusesList, currency);

  const bonus = activatedBonus || selectedBonus || listBonus;

  const rawMin = bonus ? getBonusMinDeposit(bonus, currency) : 0;
  const minBonusAmount = rawMin > 0 ? rawMin : FALLBACK_MIN_BONUS_AMOUNT;

  console.log('minBonusAmount', minBonusAmount);

  const subtitle = useLabel('quick_deposit_to_activate', {
    currency,
    minBonusAmount,
  });

  const { handleCloseClick, handleDepositStart, handleDepositSuccess } = useQuickDepositPostHog({
    afterDelay,
    onCloseClick,
  });

  const setRedirectUrl = useSetRedirectUrl();

  return (
    <DefaultPopup
      className="quick-deposit"
      headerTitle="quick_deposit_header"
      headerTitleClass="quick-deposit-header"
      headerTitlePosition="left"
      onClose={handleCloseClick}
      postHeaderTitle={subtitle}
    >
      <QuickDepositForm
        closeQRCodeOnSuccess
        onClose={onClose}
        onDepositStart={handleDepositStart}
        onDepositSuccess={handleDepositSuccess}
        setRedirectUrl={setRedirectUrl}
        titleType={QUICK_DEPOSIT_POPUP_TITLE_TYPE.QUICK_DEPOSIT}
      />
    </DefaultPopup>
  );
};

QuickDepositPopupContent.propTypes = {
  afterDelay: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func.isRequired,
};
const QuickDepositPopup = props => {
  return <QuickDepositPopupContent {...props} />;
};

QuickDepositPopup.propTypes = QuickDepositPopupContent.propTypes;

export default QuickDepositPopup;
